(function (app) {

    app.provider("retireUpApi",
        [
            function () {
                this.$get = [
                    "complianceHubApiGateway", function (complianceHubApiGateway) {
                        var service = {};

                        service.initiateRetireUpSso = function (transactionId) {
                            return complianceHubApiGateway.post("/RetireUpSso/" + transactionId);
                        };

                        return service;
                    }
                ];
            }
        ]);
})(window.app); //jshint ignore:line